<template>
  <div>
    <DxBox :height="550" direction="row" width="100%">
      <DxItem :ratio="1">
        <R3DetailsMenu ref="detailsMenu" @menu-change="menuSelectionChange" :isOperator="isOperator"
          :selectedMenuIndex="selectedMenuIndex" />
      </DxItem>
      <DxItem :ratio="3">
        <component :is="activeDetailComponent" v-if="shouldShowComponent" :containerId="containerId"
          :container="container" :isOperator="isOperator" ref="activeComponent" v-bind="componentProps" />
      </DxItem>
    </DxBox>
  </div>

</template>

<script>

import R3DetailsMenu from "@/components/container/container-details-menu.vue";
import { DxBox, DxItem } from 'devextreme-vue/box';

export default {
  components: {
    R3DetailsMenu,
    DxBox,
    DxItem,
  },
  created() {
    this.activeDetailComponent = null;
  },
  mounted() {
    this.setDefaultComponent();
  },
  props: ['containerId', 'container', 'isOperator', 'isPopupOpen'],
  data() {
    return {
      activeDetailComponent: null,
      selectedMenuIndex: null,
    };
  },
  computed: {
    shouldShowComponent() {
      return this.activeDetailComponent !== null;
    }

  },
  watch: {
    async containerId(newId, oldId) {
      if (this.isFirstLoad) {
        this.setDefaultComponent();
        this.isFirstLoad = false;
      } else {
        this.maintainCurrentMenuSelection();

      }
    },

    async isPopupOpen(newVal, oldVal) {
      if (!newVal) {
        this.resetMenuState();
      }
    }
  },
  methods: {
    menuSelectionChange(menuData) {
      this.activeDetailComponent = menuData.component;
      this.selectedMenuIndex = menuData.index;
    },
    setDefaultComponent() {
      this.$nextTick(() => {
        if (this.$refs.detailsMenu) {
          const firstMenuItem = this.$refs.detailsMenu.visibleMenuItems[0];
          if (firstMenuItem) {
            this.activeDetailComponent = firstMenuItem.component;
            this.selectedMenuIndex = firstMenuItem.id;
          }
        }
      });
    },
    maintainCurrentMenuSelection() {
      this.$nextTick(() => {
        if (this.$refs.detailsMenu && this.selectedMenuIndex !== null) {
          const selectedItem = this.$refs.detailsMenu.visibleMenuItems.find(item => item.id === this.selectedMenuIndex);
          if (selectedItem) {
            this.activeDetailComponent = selectedItem.component;
            this.resetComponentEditingStates();
          }
        }
      });
    },
    resetMenuState() {
      this.isFirstLoad = true;
      this.selectedMenuIndex = null;
      this.activeDetailComponent = null;
    },
    resetComponentEditingStates() {
      this.$nextTick(() => {
        const activeComponent = this.$refs.activeComponent;
        if (activeComponent && activeComponent.drawerOpen) {
          activeComponent.drawerOpen = false;
        }
      });
    }
  },
};

</script>

<style scoped></style>
